import styled from 'styled-components';

export const FormWrapper = styled.form`
  margin-top: 16px;
`;

export const Input = styled.input<{ error?: boolean }>`
  display: block;
  width: 100%;
  font-size: 16px;
  line-height: 26px;
  font-weight: 300;
  padding: 8px 16px;
  ${(props) =>
    props.error ? 'border: 1px solid #d43900' : 'border: 1px solid #a5adb5'};
  &:focus {
    border: 1px solid #333f48;
    outline: 1px solid #333f48;
  }
`;

export const InputWrapper = styled.div`
  padding-bottom: 18px;
  position: relative;
`;

export const LabelContent = styled.label<{ withAsterisk?: boolean }>`
  &::after {
    content: '*';
    margin-left: 4px;
    color: #0081c6;
    ${(props) => (props.withAsterisk ? 'display: inline' : 'display: none')};
  }
`;

export const ErrorMessage = styled.div`
  color: #d43900;
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  bottom: 0;
`;

export const TextArea = styled.textarea<{ error: boolean }>`
  display: block;
  width: 100%;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 16px;
  ${(props) =>
    props.error ? 'border: 1px solid #d43900' : 'border: 1px solid #a5adb5'};
  &:focus {
    border: 1px solid #333f48;
    outline: 1px solid #333f48;
  }
`;

export const CancelButton = styled.a`
  display: block;
  line-height: 24px;
  cursor: pointer;
  margin-left: 16px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
`;

export const SignedInUserWrapper = styled.div`
  margin-bottom: 18px;
  margin-top: -6px;
`;
